// /src/pages/private/members/academyTools/components/AcademyHeader.jsx
// input-security: verified — fields: member-academy-header__search (via HubToolbarSearch)

import React from 'react';
import { useTranslation } from 'react-i18next';
import HubToolbarSearch from '../../../../../components/tools/HubToolbarSearch';
function AcademyViewModeToggle({ viewMode, onViewModeChange }) {
  return (
    <div
      className="member-academy-header__view-toggle"
      role="group"
      aria-label="Academy document display mode"
    >
      <button
        type="button"
        className={[
          'member-academy-header__toggle-btn',
          viewMode === 'card' ? 'member-academy-header__toggle-btn--active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => onViewModeChange('card')}
        title="Card view"
        data-resource="private.navbar.academy"
        data-action="read"
        data-description="Academy → Card view"
      >
        Card
      </button>
      <button
        type="button"
        className={[
          'member-academy-header__toggle-btn',
          viewMode === 'list' ? 'member-academy-header__toggle-btn--active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={() => onViewModeChange('list')}
        title="List view"
        data-resource="private.navbar.academy"
        data-action="read"
        data-description="Academy → List view"
      >
        List
      </button>
    </div>
  );
}

export default function AcademyHeader({ searchTerm, onSearchTermChange, viewMode, onViewModeChange }) {
  const { t } = useTranslation();

  return (
    <header className="member-academy-header">
      <div className="member-academy-header__top">
        <div className="member-academy-header__title-wrap">
          <div className="member-academy-header__lines" aria-hidden="true">
            <span />
            <span />
          </div>
          <h2 className="member-academy-header__title">{t('academyPageTitle')}</h2>
        </div>

        <div className="member-academy-header__search">
          <HubToolbarSearch
            value={searchTerm}
            placeholder={t('academySearchPlaceholder')}
            onChange={onSearchTermChange}
            resourceKey="private.navbar.academy"
            action="read"
            description="Academy → Search documents"
          />
        </div>      </div>

      <div className="member-academy-header__toolbar">
        <AcademyViewModeToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </header>
  );
}
